(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outdoer-edit-toggle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function otWake(panel) {
      if (!panel) return;
      var imgs = panel.querySelectorAll('img');
      Array.prototype.forEach.call(imgs, function (img) {
        if (img.complete && img.naturalWidth > 0) return;
        img.loading = 'eager';
      });
      window.requestAnimationFrame(function () {
        Array.prototype.forEach.call(imgs, function (img) {
          if (img.dataset.otKicked) return;
          if (img.complete && img.naturalWidth > 0) return;
          img.dataset.otKicked = '1';
          var ss = img.getAttribute('srcset');
          var s = img.getAttribute('src');
          if (ss) { img.setAttribute('srcset', ss); }
          if (s) { img.setAttribute('src', s); }
        });
      });
    }
    function otWakeWhenSeen(panel) {
      if (!panel || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { io.disconnect(); otWake(panel); return; }
        }
      }, { rootMargin: '200px 0px' });
      io.observe(panel);
    }
    document.querySelectorAll('[data-ot-etog]').forEach(function (sec) {
      var tabs = sec.querySelectorAll('.ot-etog__tab');
      var panels = sec.querySelectorAll('[data-panel]');
      var titleWomen = sec.querySelector('[data-women]');
      var titleMen = sec.querySelector('[data-men]');
      var viewAll = sec.querySelector('[data-view-all]');
      var viewAllLabel = sec.querySelector('[data-view-all-label]');

      function setGender(g) {
        sec.setAttribute('data-gender', g);
        tabs.forEach(function (t) {
          var active = t.getAttribute('data-tab') === g;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-panel') !== g;
          if (!p.hidden) { otWake(p); }
        });
        if (viewAll) {
          var href = viewAll.getAttribute('data-' + g + '-href');
          var count = viewAll.getAttribute('data-' + g + '-count');
          if (href) viewAll.setAttribute('href', href);
          if (viewAllLabel && count) viewAllLabel.textContent = 'View all ' + count;
        }
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          setGender(t.getAttribute('data-tab'));
        });
      });

      // Initialize from data-gender attribute
      var initial = sec.getAttribute('data-gender') || 'women';
      setGender(initial);
      otWakeWhenSeen(sec.querySelector('[data-panel]:not([hidden])'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outdoer-new-to-outdoer"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ot-nto]').forEach(function (sec) {
      var btns = sec.querySelectorAll('[data-gender-btn]');
      var panels = sec.querySelectorAll('[data-panel]');
      var topLinks = sec.querySelectorAll('[data-top-link]');
      var formulaLinks = sec.querySelectorAll('[data-formula-link]');
      var activityLinks = sec.querySelectorAll('[data-activity-link]');
      var activityImgs = sec.querySelectorAll('[data-activity-img]');
      function setGender(g) {
        sec.setAttribute('data-gender', g);
        btns.forEach(function (b) {
          var on = b.getAttribute('data-gender-btn') === g;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== g; });
        topLinks.forEach(function (l) {
          var href = l.getAttribute('data-' + g + '-href');
          if (href) l.setAttribute('href', href);
        });
        formulaLinks.forEach(function (l) {
          var href = l.getAttribute('data-' + g + '-href');
          if (href) l.setAttribute('href', href);
        });
        activityLinks.forEach(function (l) {
          var href = l.getAttribute('data-' + g + '-href');
          if (href) l.setAttribute('href', href);
        });
        activityImgs.forEach(function (l) {
          var bg = l.getAttribute('data-' + g + '-bg');
          if (bg) l.style.backgroundImage = "url('" + bg + "')";
          var nm = l.getAttribute('data-' + g + '-name');
          if (nm) {
            var lbl = l.querySelector('.ot-nto__activity-label');
            if (lbl) lbl.textContent = nm;
          }
        });
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var g = b.getAttribute('data-gender-btn');
          setGender(g);
          // Persist the chosen gender so a page reload (or revisit) keeps the
          // user on their preferred view. Wrapped in try/catch because
          // localStorage can throw in private browsing / sandboxed contexts.
          try { localStorage.setItem('outdoer-gender', g); } catch (e) {}
        });
      });
      // On init, read the persisted gender if any. Default to 'women' (matches
      // the existing data-gender attribute / first-paint render).
      var initialGender = 'women';
      try {
        var saved = localStorage.getItem('outdoer-gender');
        if (saved === 'women' || saved === 'men') initialGender = saved;
      } catch (e) {}
      setGender(initialGender);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outdoer-place-parallax"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-ot-place]');
    sections.forEach((section) => {
      const bg = section.querySelector('[data-ot-place-bg]');
      const locText = section.querySelector('[data-ot-place-location-text]');
      const dataEl = section.querySelector('[data-ot-place-data]');
      if (!bg || !dataEl) return;

      let scenes = [];
      try {
        scenes = JSON.parse(dataEl.textContent).scenes || [];
      } catch (e) { return; }
      if (!scenes.length) return;

      const pick = scenes[Math.floor(Math.random() * scenes.length)];
      if (pick && pick.image) {
        bg.style.backgroundImage = "url('" + pick.image + "')";
      }
      if (locText && pick && pick.location) {
        locText.textContent = pick.location;
      }

      // Parallax: translate bg slower than scroll when section is in view
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let rafPending = false;
      const onScroll = () => {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(() => {
          const rect = section.getBoundingClientRect();
          const viewportH = window.innerHeight;
          if (rect.bottom < 0 || rect.top > viewportH) {
            rafPending = false;
            return;
          }
          // Progress: 0 when section first enters viewport from bottom,
          //           1 when section exits top of viewport.
          const total = rect.height + viewportH;
          let progress = (viewportH - rect.top) / total;
          progress = Math.max(0, Math.min(1, progress));
          // Image is 200% height (top: -50%), giving sectionH of overflow room.
          // Translate across full overflow for maximum visible motion.
          const overflow = bg.offsetHeight - section.offsetHeight;
          const translate = (0.5 - progress) * overflow;
          bg.style.transform = 'translate3d(0,' + translate.toFixed(1) + 'px,0)';
          rafPending = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outdoer-set-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ot-set]').forEach(function (sec) {
      var curVariants = JSON.parse(sec.querySelector('[data-current-variants]').textContent);
      var parVariants = JSON.parse(sec.querySelector('[data-partner-variants]').textContent);
      var curPos = parseInt(sec.getAttribute('data-current-color-pos')) || 1;
      var parPos = parseInt(sec.getAttribute('data-partner-color-pos')) || 1;
      var imgCurrent = sec.querySelector('[data-img-current]');
      var imgPartner = sec.querySelector('[data-img-partner]');
      var selectedLabel = sec.querySelector('[data-selected-color]');
      var addBtn = sec.querySelector('[data-add-set]');
      var addLabel = sec.querySelector('[data-add-label]');
      var swatches = sec.querySelectorAll('.ot-set__swatch');

      var selectedColor = null;
      var curVariantId = null;
      var parVariantId = null;

      function findVariantId(variants, pos, color) {
        var key = 'option' + pos;
        var lc = color.toLowerCase().trim();
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v[key] && String(v[key]).toLowerCase().trim() === lc) return v;
        }
        return null;
      }

      function setColor(color) {
        selectedColor = color;
        if (selectedLabel) selectedLabel.textContent = color;
        var cv = findVariantId(curVariants, curPos, color);
        var pv = findVariantId(parVariants, parPos, color);
        curVariantId = cv ? cv.id : null;
        parVariantId = pv ? pv.id : null;
        if (cv && cv.image && imgCurrent) imgCurrent.src = cv.image;
        if (pv && pv.image && imgPartner) imgPartner.src = pv.image;
        swatches.forEach(function (s) {
          s.classList.toggle('is-active', s.getAttribute('data-color') === color);
        });
        var avail = (cv && cv.available) && (pv && pv.available);
        if (addBtn) {
          addBtn.disabled = !avail;
          if (addLabel) addLabel.textContent = avail ? 'Add the set to cart' : 'Sold out';
        }
      }

      // Color swatch fill — apply hex via CSS var on each dot using a tiny built-in map
      var COLOR_MAP = {"black":"#1C1C1C","white":"#FAFAF7","ivory":"#F4F0E6","ecru":"#F2E8D2","bone":"#E8DECB","cream":"#F2EBD9","linen":"#E5DCC2","oat":"#E0D4B8","beige":"#D9CFB8","sand":"#D6C8A1","tan":"#C8A878","clay":"#B89074","stone":"#B0A89C","leather":"#3C352B","navy":"#1F2B44","oxford":"#002147","blue":"#3F5A82","maltese blue":"#3F5A82","sky":"#9DBED1","arctic":"#E4EDF1","lake":"#3F5A56","teal":"#2F726E","sage":"#9CA98C","olive":"#6E6F49","forest":"#2F3B2C","green":"#4F6A4A","heather":"#9C9C99","grey":"#8E8E8C","gray":"#8E8E8C","silver":"#C8C8C5","ash":"#5A5A57","slate":"#5C6471","charcoal":"#2D2D2D","red":"#9E3A2A","rust":"#A65A3A","amber":"#C28F3A","gold":"#B89A56","pink":"#D4A8A8","blush":"#E2BDB1","rose":"#B97A77","plum":"#5C3F4F","wine":"#5A2D3A","burgundy":"#5C2026","purple":"#5C3F66","lavender":"#B4A1C2"};
      sec.querySelectorAll('.ot-set__swatch-dot').forEach(function (dot) {
        var name = dot.getAttribute('data-color-name') || '';
        var hex = COLOR_MAP[name];
        if (!hex) {
          // try last word match
          var words = name.split(' ').reverse();
          for (var i = 0; i < words.length; i++) {
            if (COLOR_MAP[words[i]]) { hex = COLOR_MAP[words[i]]; break; }
          }
        }
        if (!hex) hex = name.replace(/ /g,'');
        dot.style.backgroundColor = hex;
      });

      swatches.forEach(function (s) {
        s.addEventListener('click', function () { setColor(s.getAttribute('data-color')); });
      });

      // Initialize with first color
      if (swatches.length > 0) setColor(swatches[0].getAttribute('data-color'));

      // Add to cart — atomic add of both variants
      addBtn && addBtn.addEventListener('click', function () {
        if (!curVariantId || !parVariantId) return;
        addBtn.disabled = true;
        addLabel.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [
            { id: curVariantId, quantity: 1 },
            { id: parVariantId, quantity: 1 }
          ]})
        }).then(function (r) { return r.json(); }).then(function (data) {
          addLabel.textContent = 'Added to cart ✓';
          // Open cart drawer if the theme dispatches a known event
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
          window.dispatchEvent(new CustomEvent('outdoer:cart:added', { detail: data }));
          setTimeout(function () { addLabel.textContent = 'Add the set to cart'; addBtn.disabled = false; }, 1800);
        }).catch(function () {
          addLabel.textContent = 'Try again';
          addBtn.disabled = false;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outdoer-styled-by-you"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ot-styled]').forEach(function (sec) {
      var track = sec.querySelector('[data-ot-styled-track]');
      var prev = sec.querySelector('[data-ot-styled-prev]');
      var next = sec.querySelector('[data-ot-styled-next]');
      if (!track) return;
      var step = function () { return track.clientWidth * 0.8; };
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      // Close all other tags when one opens. Also flip the tooltip
      // direction: if the tag sits in the lower half of the look
      // image, render the tooltip ABOVE the + so it doesn't get cut
      // off at the bottom of the image / hidden behind sibling +s.
      sec.querySelectorAll('.ot-styled__tag').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) {
            sec.querySelectorAll('.ot-styled__tag').forEach(function (other) {
              if (other !== d) other.open = false;
            });
            // Compute the tag's vertical position within its image wrap.
            var wrap = d.closest('.ot-styled__img-wrap');
            if (wrap) {
              var wrapRect = wrap.getBoundingClientRect();
              var tagRect = d.getBoundingClientRect();
              var relativeY = (tagRect.top + tagRect.height / 2 - wrapRect.top) / wrapRect.height;
              if (relativeY > 0.55) {
                d.classList.add('ot-styled__tag--flip-up');
              } else {
                d.classList.remove('ot-styled__tag--flip-up');
              }
            }
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
